import {Route, Routes, Navigate} from "react-router-dom";
import TemplatesList from "./pages/TemplatesList/TemplatesList";
import CreateTemplate from "./pages/CreateTemplate/CreateTemplate";
import TemplateDetail from "./pages/TemplateDetail/TemplateDetail";
import EditTemplate from "./pages/EditTemplate/EditTemplate";
import PageNotFound from "../../util/page/PageNotFound";
import { useTemplateHelpers } from "./hooks/useTemplateHelpers";

const TemplatesMain = () => {
    useTemplateHelpers();

    return (
        <Routes>
            <Route index element={<Navigate to="list" replace/>}/>
            <Route path="/list" element={<TemplatesList/>}/>
            <Route path="/create" element={<CreateTemplate/>}/>
            <Route path="/view/:name" element={<TemplateDetail/>}/>
            <Route path="/edit/:name" element={<EditTemplate/>}/>
            <Route path="*" element={<PageNotFound/>}/>
        </Routes>
    );
};

export default TemplatesMain;
